import T from './types';
import LOADER from '@ott/utility-loader';

const initialState = {
  from: { status: LOADER.initial(), items: null },
  to: { status: LOADER.initial(), items: null },
  cache: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case T.SUGGEST_GET: {
      const { slug } = action;

      let items = null;

      if (state[slug] && state[slug].items) {
        items = state[slug].items;
      }

      return {
        ...state,
        [slug]: {
          status: LOADER.begin(),
          items,
        },
      };
    }
    case T.SUGGEST_GET_SUCCESS: {
      const { slug, result } = action;

      return {
        ...state,
        [slug]: {
          status: LOADER.success(),
          items: result && result[slug],
        },
      };
    }
    case T.SUGGEST_GET_FAIL: {
      const { slug, error } = action;

      return {
        ...state,
        [slug]: {
          status: LOADER.error(error),
          items: null,
        },
      };
    }
    case T.SUGGEST_RESET: {
      const { slug } = action;

      return {
        ...state,
        [slug]: { status: LOADER.initial() },
      };
    }
    case T.SUGGEST_CACHE: {
      const { data, mode, id } = action;
      const {
        cache,
        cache: { [mode]: restData },
      } = state;

      return {
        ...state,
        cache: {
          ...cache,
          [mode]: {
            ...restData,
            [id]: data,
          },
        },
      };
    }
    default:
      return state;
  }
}
